import { atom, useAtom } from 'jotai';

export const manageDocsEnvironmentAtom = atom(undefined);

export function useManageDocsEnvironmentAtom() {
    return useAtom(manageDocsEnvironmentAtom);
  }